<template>
  <div class="listview-wrapper text-medium">
    <!-- 搜索区 -->
    <div class="listview-wrapper__search" v-if="!hiddenSearch">
      <!-- 第一行默认带搜索 -->
      <div class="listview-wrapper__search__first-line">
        <div class="listview-wrapper__search__first-line__filter">
          <slot name="filter">
            <col-item :default-input="defaultInput" @queryFirstPage="queryFirstPage" @resetList="resetList"
              :isOneline="isOneline" ref="colItem" @queryEnterList="queryFirstPage" :valueData="allSearchKeyValue"
              :labelWidth="labelWidth" :searchItems="searchItems" :sperator="sperator">
              <template v-for="item in searchItems" #[item.key]>
                <slot :name="item.key" v-if="item.type === 'custom'"></slot>
              </template>
            </col-item>
          </slot>
          <!-- 更多区域 -->
          <more-condition v-if="canShowMore" :isShowMore="isMoreExpanded" class="search-more-area">
            <template #more-condition-content>
              <col-item :default-input="defaultInput" ref="moreColItem" @queryEnterList="queryFirstPage"
                :valueData="allSearchKeyValue" :labelWidth="labelWidth" :searchItems="moreSearchItems"
                :sperator="sperator">
                <template v-for="item in moreSearchItems" #[item.key]>
                  <slot :name="item.key" v-if="item.type === 'custom'"></slot>
                </template>
              </col-item>
            </template>
          </more-condition>
        </div>
        <div class="listview-wrapper__search__right-search" v-if="!isOneline">
          <div class="listview-wrapper__search__search-top-center">
            <div class="listview-wrapper__search__expand-icon-wrap" @click="toggleExpandMore" v-if="canShowMore">
              <div class="listview-wrapper__search__expand-text">
                <span v-show="!isMoreExpanded">{{ expandMoreText[0] }}</span>
                <span v-show="isMoreExpanded">{{ expandMoreText[1] }}</span>
              </div>
              <div class="listview-wrapper__search__expand-icon">
                <img :src="expandSvg" v-show="!isMoreExpanded" alt="" />
                <img :src="collaspeSvg" v-show="isMoreExpanded" alt="" />
              </div>
            </div>
            <slot name="search">
              <el-button type="primary" plain @click="resetList">重置</el-button>
              <el-button type="primary" @click="queryFirstPage">查询</el-button>
            </slot>
          </div>
        </div>
        <div class="online-operate-area" v-else>
          <slot name="operate"></slot>
        </div>
      </div>
    </div>
    <!-- operate btnq区域 -->
    <div class="listview-wrapper__operate-area" :class="{ 'hidden-search-operate': hiddenSearch }" v-if="!isOneline"
      v-show="$slots.operate">
      <div class="listview-wrapper__operate-btn-group">
        <slot name="operate"></slot>
      </div>
    </div>
    <!-- table区 -->
    <div class="listview-wrapper__table-wrapper">
      <slot name="table"></slot>
    </div>
    <div class="listview-wrapper__page-wrapper" v-show="!hiddenPagination">
      <slot name="pagination">
        <div class="listview-wrapper__pagination">
          <div class="pagination-left-area">
            <slot name="pageLeft"></slot>
          </div>
          <el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange"
            :current-page="pageParams.pageNo" :page-sizes="pageSizes" :page-size="pageParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRecords"></el-pagination>
        </div>
      </slot>
    </div>
    <slot name="popup"></slot>
  </div>
</template>

<script>
import MoreCondition from "../../ExpandCondition/index";
// import TqPagination from "../../Pagination";
import ColItem from "./components/colItem.vue";
import expandSvg from "../../../assets/images/btn_gd.svg";
import collaspeSvg from "../../../assets/images/btn_sq.svg";

export default {
  name: "TqListView",
  components: { MoreCondition, ColItem },
  data() {
    return {
      isMoreExpanded: false,
      pageParams: {
        pageNo: 1,
        pageSize: this.pageSizes[0] || 20,
      },
      sortParams: {
        sort: '', //排序字段
        order: '', //必须为asc或desc
      },
      allSearchKeyValue: {},
      allSearchKeyValueBack: {},
      expandSvg,
      collaspeSvg,
    };
  },
  computed: {
    canShowMore() {
      return this.$slots.filterMore || this.moreSearchItems.length > 0;
    },
  },
  props: {
    searchItems: {
      type: Array,
      default() {
        return [];
      },
    },
    moreSearchItems: {
      type: Array,
      default() {
        return [];
      },
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    defaultInput: {
      type: Number,
      default: 100000,
    },
    initLoadData: {
      type: Boolean,
      default: true,
    },
    hiddenPagination: {
      type: Boolean,
      default: false,
    },
    hiddenSearch: {
      type: Boolean,
      default: false,
    },
    sperator: {
      type: String,
      default: "：",
    },
    isOneline: {
      type: Boolean,
      default: false
    },
    // 继承tab的高度
    inheritTabHeight: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: "",
    },
    pageSizes: {
      type: Array,
      default() {
        return [20, 50, 100];
      }
    },
    // “更多” 是否默认展开
    defaultExpandMore: {
      type: Boolean,
      default: false
    },
		expandMoreText:{
			type: Array,
			default() {
				return ['更多', '收起']
			}
		}
  },
  methods: {
    clearAllSelectorLabel() {
      if (this.$refs.colItem && this.$refs.colItem.clearAllSelectorLabel) {
        this.$refs.colItem.clearAllSelectorLabel();

      }
      if (this.$refs.moreColItem && this.$refs.moreColItem.clearAllSelectorLabel) {
        this.$refs.moreColItem.clearAllSelectorLabel();

      }
    },
    getSearchKeyValue(searchItems, moreSearchItems) {
      const tmpObj = {};
      if (searchItems && searchItems.length > 0) {
        for (let index = 0; index < searchItems.length; index++) {
          const element = searchItems[index];
          tmpObj[element.key] = element.value;
        }
      }
      if (moreSearchItems && moreSearchItems.length > 0) {
        for (let index = 0; index < moreSearchItems.length; index++) {
          const element = moreSearchItems[index];
          tmpObj[element.key] = element.value;
        }
      }
      return tmpObj;
    },
    queryFirstPage() {
      this.handleCurrentChange(1);
    },
    toggleExpandMore() {
			this.$emit('toggleExpandMore')
      this.isMoreExpanded = !this.isMoreExpanded;
    },
    resetList() {
      this.$emit('resetList');
      for (const key in this.allSearchKeyValueBack) {
        if (Object.hasOwnProperty.call(this.allSearchKeyValueBack, key)) {
          const element = this.allSearchKeyValueBack[key];
          this.allSearchKeyValue[key] = element;
        }
      }
      // 清空人员选择器和部门选择器的label
      this.clearAllSelectorLabel();
      // 重置页码
      this.pageParams.pageNo = 1;
      // 重置排序
      this.sortParams.sort = ""
      this.sortParams.order = ""
      const tableChildren = this.$children || []
      this.clearSortAllRecursion(tableChildren)
      // 开始查询
      this.queryList();
    },
    // 递归找到所有name为tq-table的子组件，判断子组件中是否有clearSort方法，如果有就执行clearSort方法
    clearSortAllRecursion(tableChildren = []) {
      for (let index = 0; index < tableChildren.length; index++) {
        const element = tableChildren[index];
        if (element && element.$options && element.$options.name === 'TqTable') {
          if (element.clearSort) {
            console.log('start reset clear');
            element.clearSort()
          }
        } else {
          if (element.$children && element.$children.length > 0) {
            this.clearSortAllRecursion(element.$children)
          }
        }
      }
    },
    trimStringValues(obj) {
      for (let key in obj) {
        if (typeof obj[key] === 'string') {
          obj[key] = obj[key].trim();
        }
      }
      return obj;
    },
    getAllParams() {
      const allQueryParams = {
        ...this.allSearchKeyValue,
        ...this.pageParams,
      }
      if (this.sortParams.order && this.sortParams.sort) {
        allQueryParams.order = this.sortParams.order
        allQueryParams.sort = this.sortParams.sort
      }
      return this.trimStringValues(allQueryParams)
    },
    queryList() {
      const allQueryParams = this.getAllParams()
      this.$emit("queryList", allQueryParams);
    },
    // 选择页面条数
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.handleCurrentChange(1);
    },
    // 和tq-table耦合的一个方法
    getSortData(sortObj) {
      if (sortObj.order) {
        this.sortParams.sort = sortObj.prop
        this.sortParams.order = sortObj.order === 'ascending' ? 'asc' : 'desc'
      } else {
        this.sortParams.sort = ""
        this.sortParams.order = ""
      }
      this.queryList()
    },
    // 跳转页面
    handleCurrentChange(val) {
      this.pageParams.pageNo = val;
      this.queryList();
    },
    copyObjectArrs(arrs = []) {
      // 方法不能copy
      let tmpArr = [];
      let tmpObj = {};
      for (let index = 0; index < arrs.length; index++) {
        const element = arrs[index];
        tmpObj = {};
        for (const key in element) {
          if (Object.hasOwnProperty.call(element, key)) {
            const value = element[key];
            if (typeof value === "function") {
              tmpObj[key] = value;
            } else {
              tmpObj[key] = JSON.parse(JSON.stringify(value));
            }
          }
        }
        tmpArr.push(tmpObj);
      }
      return tmpArr;
    },
    doInheritTabHeight() {
      if (this.inheritTabHeight) {
        const element = this.$parent.$parent.$el;
        // 为element添加一个名为 'inherit-tab-height' 的class
        element.classList.add('inherit-tab-height')
      }
    },
    // 手动改变value值，慎用，或破坏数据流
    changeInnerValue(key, value) {
      this.allSearchKeyValue[key] = value;
    },
  },
  created() {
    const initKeyValues = this.getSearchKeyValue(this.searchItems, this.moreSearchItems);
    for (const key in initKeyValues) {
      if (Object.hasOwnProperty.call(initKeyValues, key)) {
        const element = initKeyValues[key];
        this.allSearchKeyValue[key] = element;
        this.allSearchKeyValueBack[key] = element;
      }
    }

    if (this.initLoadData) {
      this.queryList();
    }
  },
  mounted() {
    this.doInheritTabHeight()
  },
  watch: {
    'allSearchKeyValue': {
      handler: function (val) {
        this.$emit('searchValueChanged', val);
      },
      deep: true
    },
    'defaultExpandMore': {
      handler(val) {
        this.isMoreExpanded = val;
      },
      immediate:true
    }
  }
};
</script>
